import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import { CkeditorConstants } from "../../src/utils";

const {
  commentAttributes: { RESOLVE },
  class: { CK_COMMENT_RESOLVE },
  helperAttributes: { DATA_COMMENT, DATA_THREAD_ID, DATA_COMMENT_THREAD_ID },
  localStorageItem: { trackchangesandcommentsdata, IS_ALL_COMMENT_DELETED },
  DATA_COMMENT_ATTRIBUTES,
} = CkeditorConstants;

/**
 * Use for overide backgroung color for comment By status (For now resolve)
 */
export default class RemoveMarkupForResolvedComment extends Plugin {
  init() {
    const editor = this.editor;
    editor.conversion.for("downcast").markerToHighlight({
      model: "comment",
      view: (data, _conversionApi) => {
        const isAllCommentDeleted = localStorage.getItem(
          IS_ALL_COMMENT_DELETED
        );
        const commentsRepository = this.editor.plugins.get(
          "CommentsRepository"
        );
        let commentThreads = commentsRepository.getCommentThreads({
          skipNotAttached: true,
          skipEmpty: true,
          toJSON: true,
        });
        /** onload ckeditor commentThreads is not initialize so we need to get data from localstorage */
        const _commentThreads = commentThreads.length
          ? commentThreads
          : JSON.parse(localStorage.getItem(trackchangesandcommentsdata))
            .commentThreads;
        const [, threadId] = data.markerName.split(":");


        const resolvedIds = _commentThreads
          .filter(
            (thread) =>
              thread.comments?.[0]?.attributes?.status === RESOLVE
          )
          .map((thread) => thread.threadId)

        const isResolved = resolvedIds.includes(threadId);
        if (isAllCommentDeleted === "true") {
          const range = this.editor.model.createRangeIn(
            this.editor.model.document.getRoot()
          );
          const dataCommentElement = [];
          for (let item of range.getItems({ ignoreElementEnd: true })) {
            for (let i = 0; i < DATA_COMMENT_ATTRIBUTES.length; i++) {
              if (item.hasAttribute(DATA_COMMENT_ATTRIBUTES[i])) {
                dataCommentElement.push(item);
                break;
              }
            }
          }
          editor.model.change((writer) => {
            if (dataCommentElement.length > 0) {
              for (let i = 0; i < dataCommentElement.length; i++) {
                DATA_COMMENT_ATTRIBUTES.forEach((attr) => {
                  writer.removeAttribute(attr, dataCommentElement[i]);
                });
              }
            }
          });
          localStorage.removeItem(IS_ALL_COMMENT_DELETED);
        }
        if (isResolved) {

          // Checks resolved ids and removes the comment marker in the document
          const resolvedIdSet = new Set(resolvedIds.toString().split(','));

          const marker = [...this.editor.model.markers._markers].find(([markerId]) => {
            const idFromMarker = markerId.split(":")[1];
            return resolvedIdSet.has(idFromMarker);
          });

          if (marker) {
            this.editor.model.change(writer => {
              writer.removeMarker(marker[0]);
            });
          }
        }

        this.addCustomDataComment(data, _conversionApi);
        this.removeCustomCommentAtrr(data, commentThreads);
      },
      converterPriority: "high",
    });
  }

  /**
   * Add Custom Comment dataset for Figure
   * @param {*} data 
   * @param {*} conversionApi 
   */
  addCustomDataComment(data, conversionApi) {
    const [, commentId,] = data.markerName.split(':');
    const name = (data.item && data.item.name) ? data.item.name : null;
    if (commentId &&
      (name === 'table' ||
        name === 'figureTag' ||
        name === 'inlineaudio' ||
        name === 'inlineimage')
    ) {
      const viewElement = conversionApi.mapper.toViewElement(data.item);
      let isSame_Custom_Comment_Present = viewElement.hasAttribute(DATA_COMMENT_THREAD_ID) ? (viewElement.getAttribute(DATA_COMMENT_THREAD_ID) === commentId) : false;

      if (!isSame_Custom_Comment_Present) {
        const viewWriter = conversionApi.writer;
        viewWriter.setAttribute(DATA_COMMENT_THREAD_ID, commentId, viewElement);
      }
    }
  }

  /**
  * Removes Custom Added comment attribute if comment not posted.
  * @param {*} data 
  */
  removeCustomCommentAtrr(data, commentThreads) {
    if (data.markerName && !data.item) {
      const [, commentId,] = data.markerName.split(":");
      let threads = commentThreads.map((item) => item.threadId);
      /** onload ckeditor commentThreads is not initialize so we need to get data from localstorage */
      const _commentThreads = threads.length
        ? threads
        : JSON.parse(localStorage.getItem(trackchangesandcommentsdata))
          .commentThreads;
      let isThreadAvailable;
      if (_commentThreads.length > 0 && !_commentThreads.includes(commentId))
        isThreadAvailable = false;

      if (isThreadAvailable === false) {
        let editingDomRoot = []
        this.editor.editing.view.change((writer) => {
          const range = writer.createRangeIn(
            this.editor.editing.view.document.getRoot('main')
          );
          for (const item of range.getItems()) {
            if (item._attrs &&
              (item.hasAttribute(DATA_COMMENT_THREAD_ID))
            ) {
              editingDomRoot.push(item);
            }
          }

          editingDomRoot.forEach(element => {
            if (commentId &&
              !element.data &&
              (element.getAttribute(DATA_COMMENT_THREAD_ID) === commentId)
            ) {
              writer.removeAttribute(
                DATA_COMMENT_THREAD_ID,
                element
              );
            }
          });
        });
      }
    }
  }
}
